export const portfolioContent = {
    "name": "Gagan Sharma",
    "title": "Software Developer",
    "tagline": "Building scalable, high-performance systems and innovative AI solutions.",
    "email": "me@gagan-sharma.com",
    "personalEmail": "",
    "github": "https://github.com/gagan-gh",
    "linkedin": "https://linkedin.com/in/gagan-sh/",
    "phone": "",
    "website": "https://gagan-sharma.com",
    "professionalSummary": "Software Engineer with 3+ years of experience building scalable backend systems and AI platform infrastructure. Currently architecting agentic AI platforms, guardrail systems, and distributed GenAI services powering production applications. Proven ability to improve reliability, latency, and cost through strong system design, secure execution frameworks, and cloud-native engineering using Python, Go, and AWS.",
    "about": {
        "intro": "Backend and AI platform engineer specializing in agentic systems, secure LLM infrastructure, and scalable cloud-native services."
    },
    "achievements": [
        "Architected **agentic AI and guardrail platforms** for safe LLM execution, including prompt-injection defense and policy enforcement with **less than 100ms latency overhead**.",
        "Reduced vendor integration onboarding time from 15-30 days to under 1 hour, accelerating enterprise adoption at Procol.",
        "Improved system performance by **80%** at Nykaa by re-architecting critical retail invoice APIs.",
        "Scaled backend systems supporting **5 lakh+ daily orders** and **15 lakh+ SKUs** at Nykaa.",
        "Awarded **Exceptional Performance Award (Nykaa, FY 2022-23)**."
    ],
    "education": [
        {
            "level": "University",
            "name": "Guru Gobind Singh Indraprastha University",
            "degree": "B.Tech in Information Technology",
            "score": "8.2",
            "dates": "May 2018 - May 2022"
        }
    ],
    "experience": [
        {
            "company": "PayPay India",
            "title": "Software Development Engineer 2",
            "dates": "June 2025 - Present",
            "location": "Gurugram, India",
            "description": [
                "Core contributor to the **GenAI Platform team**, building scalable internal services powering AI features across multiple PayPay products.",
                "Architected and built an **agentic platform** enabling teams to create safe, cost-efficient LLM agents by automatically converting **OpenAPI specs into validated executable tools**.",
                "Designed a **dynamic graph orchestration framework** where developer-defined agent workflows are persisted and compiled into **LangGraph execution graphs at runtime**.",
                "Designed and deployed **high-throughput microservices** supporting AI-powered user-facing and internal systems.",
                "Architected a **unified GenAI Guardrails Platform** integrated with major AI providers like OpenAI, Google, AWS Bedrock, and internal solutions.",
                "Owned and maintained a **centralized catalog of AI policies** for configurable and company-specific safeguards.",
                "Implemented a **scalable enforcement service** optimizing policy execution for cost, latency, and reliability.",
                "Implemented **secure tool execution controls** including schema validation, RBAC, permission-aware access, audit logging, and prompt-injection defenses.",
                "Reduced AI workflow API costs by **~20\\%** through prompt optimization, caching, and intelligent provider routing.",
                "Conducted **LLM experimentation and evaluation** to improve performance, quality, and cost efficiency."
            ],
            "technologies": [
                "Python",
                "FastAPI",
                "Go",
                "Gin",
                "LangGraph",
                "Pydantic",
                "LangFuse",
                "Hugging Face",
                "LiteLLM",
                "Redis Streams",
                "Kafka",
                "AWS",
                "CI/CD"
            ]
        },
        {
            "company": "Nykaa",
            "title": "Software Engineer",
            "dates": "Sep 2022 - June 2025",
            "location": "Gurugram, India",
            "description": [
                "Built generative AI pipelines for automated transcript generation for product advertisements and tutorials.",
                "Integrated Nykaa Affiliate Program, increasing affiliate link generation by **30\\%** in one month.",
                "Reimplemented retail invoice APIs to **reduce response time by 80\\%**, significantly improving peak-hour stability.",
                "Developed POS system for a new franchise business vertical in collaboration with multiple teams.",
                "Built Retail Asset Booking System handling yearly revenue of **INR 30Cr**.",
                "Developed Vendor Payout System processing up to **5 lakh orders per day**.",
                "Built Inventory Allocation System managing **15 lakh+ SKUs** to improve store self-fulfillment.",
                "Conducted code reviews, delivered tech talks, and mentored interns and junior engineers."
            ],
            "technologies": [
                "Python",
                "Java",
                "SQL",
                "MongoDB",
                "AWS",
                "OpenAI",
                "Redis",
                "Celery",
                "React",
                "Svelte"
            ]
        }
    ],
    "skills": [
        {
            "group": "Artificial Intelligence",
            "skillItems": [
                "Agentic AI & Orchestration (LangGraph)",
                "AI Guardrails & Safety",
                "LLM Platforms (OpenAI, Bedrock, LiteLLM)",
                "LLM Fine-tuning & Prompt Engineering",
                "Transformers & Hugging Face",
                "Whisper (ASR)"
            ]
        },
        {
            "group": "Languages",
            "skillItems": [
                "Python",
                "Java",
                "Go",
                "JavaScript",
                "Lua",
                "TypeScript"
            ]
        },
        {
            "group": "Frameworks",
            "skillItems": [
                "FastAPI",
                "Flask",
                "Gin",
                "SpringBoot",
                "React",
                "Nest.Js",
                "Svelte"
            ]
        },
        {
            "group": "Databases",
            "skillItems": [
                "SQL",
                "Vector Databases",
                "MongoDB",
                "Redis",
                "DynamoDB"
            ]
        },
        {
            "group": "Other Tools",
            "skillItems": [
                "Git",
                "Docker",
                "Kubernetes",
                "Backstage",
                "AWS",
                "Kafka",
                "ElasticSearch",
                "New Relic",
                "Sentry",
                "Grafana"
            ]
        }
    ],
    "certifications": [
        {
            "name": "Exceptional Performance Award",
            "organization": "Nykaa",
            "description": "Awarded to employees with exceptional performance during financial year 2022-2023.",
            "link": "-"
        },
        {
            "name": "Database Management System",
            "organization": "NPTEL",
            "description": "Certification for completion of DBMS course by IIT Kharagpur.",
            "link": "-"
        }
    ],
    "is_personal": false
};

